
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides-reports/[pillar]/[slug]",
      function () {
        return require("private-next-pages/guides-reports/[pillar]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides-reports/[pillar]/[slug]"])
      });
    }
  